import { useNavigate } from "react-router-dom";
import logo from '../../assets/logo.png.png';

export default function Navbar() {
    const navigate = useNavigate();
    const onclick = () => {
    navigate ('/signup');
}
const onLogin = () => {
    navigate ('/login');
}
    return (
        <nav className="flex justify-between items-center px-8 py-4 shadow-sm">
            <img src={logo} alt="Logo" className="h-10 w-110 object-contain" />
            <div className="flex items-center gap-10">
                <ul className="hidden md:flex gap-10 text-[#202220] text-sm">
                    <li className="relative cursor-pointer decoration-[#93C893] p-2 after:absolute after:bottom-0 after:left-0  after:content-[''] after:w-0 hover:after:w-full after:h-[2px] after:transition-all after:bg-primary">Home</li>
                    <li className="relative cursor-pointer decoration-[#93C893] p-2 after:absolute after:bottom-0 after:left-0  after:content-[''] after:w-0 hover:after:w-full after:h-[2px] after:transition-all after:bg-primary">About Us</li>
                    <li className="relative cursor-pointer decoration-[#93C893] p-2 after:absolute after:bottom-0 after:left-0  after:content-[''] after:w-0 hover:after:w-full after:h-[2px] after:transition-all after:bg-primary">Services</li>
                    <li className="relative cursor-pointer decoration-[#93C893] p-2 after:absolute after:bottom-0 after:left-0  after:content-[''] after:w-0 hover:after:w-full after:h-[2px] after:transition-all after:bg-primary" onClick={() => onLogin()}>Login</li>
                </ul>
                <div className="gap-10 flex ">
                    <button className="px-4 py-2 border rounded-md text-sm border-primary">Pricing</button>
                    <button className="px-4 py-2 bg-primary text-[#141414] rounded-md text-sm" onClick={() => onclick()}>Sign Up</button>
                </div>
            </div>
        </nav>
    );
}
